module.exports = __webpack_public_path__ + "img/image (10).fe510d2c.webp";